export enum FIELD_TYPES{
	TEXT=1,
	ALL = 2,
	SELECT=4,
	CHECK_BOX = 5,
}
